import { RadioBtnProps } from "./RadioBtn";

const BasicCheckbox = ({
    text,
    name,
    color = "is-primary",
    checked = false,
    handleClick,
    className,
    style
}: RadioBtnProps) => {
    const id = Date.now().toString(36) + Math.random().toString(36);
    return (
        <div
            className={`basic-checkbox ${color} ${className}`}
            style={style}
            // onClick={() => {
            //     console.log("clicccccked");
            //     handleClick && handleClick();
            // }}
        >
            <div>
                <input
                    type="checkbox"
                    className="styled-checkbox"
                    id={id}
                    name={name}
                    checked={checked}
                    value={text}
                    onChange={() => {
                        console.log("clicccccked");
                        handleClick && handleClick();
                    }}
                />
                <label htmlFor={id}></label>
            </div>
        </div>
    );
};

export default BasicCheckbox;
